import axios from "axios";
import { apiConfig } from "../../config/api";
import secureStorage from "../../utils/secureStorage";
const API_BASE_URL = apiConfig.basePath;
// Fetch vibe badge counts for a specific date
export const getVibeBadge = async () => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const response = await axios.get(`${API_BASE_URL}get-vibe-badge`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Accept-Language": "en",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Fetch daily vibes for a specific date

export const getDailyVibe = async ({ date }) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }

    const body = { date };
    const response = await axios.post(
      `${API_BASE_URL}daily-vibe`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch a single vibe by id using POST to get-single-vibe
export const getSingleVibe = async (vibe_id) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const response = await axios.post(
      `${API_BASE_URL}get-single-vibe`,
      { vibe_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch user's favorites
export const getMyFavorites = async () => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const formData = new FormData();
    const response = await axios.post(`${API_BASE_URL}my-favorite`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Accept-Language": "en",
      },
      validateStatus: function (status) {
        // Accept 429 as a valid response, handle gracefully
        return (status >= 200 && status < 300) || status === 429;
      },
    });
    if (response.status === 429) {
      // Too Many Requests, return empty or cached data
      return { data: [] };
    }
    return response.data;
  } catch (error) {
    return { data: [] };
  }
};

// Toggle favorite status
export const handleToggleFavorite = async (vibe_id) => {
  if (!vibe_id) return;
  try {
    const token = secureStorage.getItem("accessToken");
    await axios.post(
      `${apiConfig.basePath}create-remove-favorite`,
      { vibe_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (err) {
  }
};

// Fetch all vibe categories
export const getVibeCategories = async () => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const response = await axios.get(`${API_BASE_URL}vibe-category`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Accept-Language": "en",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMyVibes = async (type, page = 1) => {
  const maxRetries = 3;
  let attempt = 0;
  let lastError;
  while (attempt < maxRetries) {
    try {
      const token = secureStorage.getItem("accessToken");
      if (!token) {
        throw new Error("No access token found");
      }

      const formData = new FormData();
      formData.append("type", type);
      formData.append("page", page);
      const response = await axios.post(`${API_BASE_URL}my-vibe`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
        },
      });
      return response.data;
    } catch (error) {
      if (error?.response?.status === 429) {
        attempt++;
        lastError = error;
        // Wait 1 second before retrying
        await new Promise((res) => setTimeout(res, 1000));
        continue;
      } else {
        throw error;
      }
    }
  }
  // If we exhausted retries, throw last 429 error
  throw lastError;
};
export const getCalenderVibe = async ({ date, page = 1, limit = 50 }) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const body = { date, page, limit };
    const response = await axios.post(
      `${API_BASE_URL}get-celender-vibe`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getVibeBulks = async () => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const response = await axios.post(
      `${API_BASE_URL}vibe-bucks`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelVibe = async (vibe_id) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) throw new Error("No access token found");
    const response = await axios.post(
      `${API_BASE_URL}cancel-vibe`,
      { vibe_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const acceptRejectVibe = async (vibe_id, action) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) throw new Error("No access token found");
    const response = await axios.post(
      `${API_BASE_URL}accept-reject-vibe`,
      { vibe_id, action }, // action should be 'accept' or 'reject'
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createVibeCategory = async (name) => {
  try {
    const token = secureStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found");
    }
    const response = await axios.post(
      `${API_BASE_URL}create-vibe-category`,
      { name },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": "en",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
